import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[appPasswordMask]'
})
export class PasswordMaskDirective {

  constructor(private readonly eleRef:ElementRef,private readonly renderer:Renderer2) { }

  @HostListener('click') toggleClick(){
    if(this.eleRef.nativeElement.previousElementSibling.attributes.type.value=='password'){
      this.eleRef.nativeElement.previousElementSibling.attributes.type.value='text';
      if(this.eleRef.nativeElement.classList.contains('fa-eye-slash')){
        this.eleRef.nativeElement.classList.replace('fa-eye-slash','fa-eye');
       }
    }else{
      this.eleRef.nativeElement.previousElementSibling.attributes.type.value='password';
      if(this.eleRef.nativeElement.classList.contains('fa-eye')){
        this.eleRef.nativeElement.classList.replace('fa-eye','fa-eye-slash');
       }
    }
  }
}
